import React from "react";
import { Typography, Avatar, Stack } from "@mui/material";

import { getUniqueContributorsAvatarURL } from "utility";
import { Shape } from "types";

type AvatarPanelProps = {
  shapes: Shape[] | undefined;
};

export const AvatarPanel: React.FC<AvatarPanelProps> = ({ shapes }) => {
  const contributors = getUniqueContributorsAvatarURL(shapes);

  if (contributors.length === 0) {
    return null;
  }

  return (
    <div>
      <Typography variant="h4" fontSize={"1.3rem"} marginBottom={2}>
        Users
      </Typography>
      <Stack direction="row" flexWrap="wrap">
        {contributors.map((avatar_url, idx) => (
          <Avatar key={avatar_url || idx} src={avatar_url} />
        ))}
      </Stack>
    </div>
  );
};
